"use strict";
/*
 * Derived from `src/compat/predicate/isArguments.ts` in es-toolkit
 * (https://github.com/toss/es-toolkit).
 *
 * Copyright (c) 2024 Viva Republica, Inc
 * Copyright OpenJS Foundation and other contributors
 *
 * Parts of the compatibility layer in `es-toolkit/compat` are derived from
 * Lodash (https://github.com/lodash/lodash) by the OpenJS Foundation
 * (https://openjsf.org/) and Underscore.js by Jeremy Ashkenas, DocumentCloud
 * and Investigative Reporters & Editors (http://underscorejs.org/).
 *
 * This file has been modified from the original source to create a standalone
 * adaptation.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArguments = void 0;
function getTag(value) {
    if (value == null) {
        return value === undefined ? "[object Undefined]" : "[object Null]";
    }
    return Object.prototype.toString.call(value);
}
function isArguments(value) {
    return (value !== null &&
        typeof value === "object" &&
        getTag(value) === "[object Arguments]");
}
exports.isArguments = isArguments;
